export default __webpack_public_path__ + "static/Group 266-bf3c4474122951bf990288094ed128f2.svg";